export default __webpack_public_path__ + "static/media/blue-group.5ab941a9.svg";